<script setup lang="ts">
import { cva } from 'class-variance-authority'
import { cn } from '@/lib/utils'

type SpinnerSize = 'sm' | 'md' | 'lg'

const props = defineProps<{
  size?: SpinnerSize
}>()

const spinnerVariants = cva(
  'border-2 border-[color:var(--color-border-soft)] border-t-current rounded-full animate-spin',
  {
    variants: {
      size: {
        sm: 'w-4 h-4',
        md: 'w-6 h-6',
        lg: 'w-8 h-8',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  },
)
</script>

<template>
  <div class="flex items-center justify-center">
    <div
      :class="cn(spinnerVariants({ size: props.size }), 'border-t-primary')"
    />
  </div>
</template>
